import { render, staticRenderFns } from "./edit-order.vue?vue&type=template&id=bf6ec7ae&"
import script from "./edit-order.vue?vue&type=script&lang=ts&"
export * from "./edit-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports